import router from "@/router/router";

export const routerStackModule: any = {
  routerStack: [],
  homeActiveIndex: 0,
  canContinueExist: ["OrderDetail"] // 可以允许多次叠加的路由
};

export const updateHomeActiveIndex = (num: number) => {
  routerStackModule.homeActiveIndex !== num &&
    (routerStackModule.homeActiveIndex = num);
};

export const routerReplace = (payload: any) => {
  routerStackModule.routerStack.shift();
  routerStackModule.routerStack.unshift(payload);
  console.log("routerStack - replace:", routerStackModule);
};

export const routerGoBack = (payLoad: number) => {
  const pathNumber = Math.abs(payLoad);
  routerStackModule.routerStack.splice(0, pathNumber);
  console.log("routerStack - goback:", routerStackModule);
};

export const routerPush = (payLoad: any) => {
  try {
    if (
      payLoad.name &&
      routerStackModule.routerStack.length > 0 &&
      routerStackModule.routerStack[0].name &&
      routerStackModule.routerStack[0].name === payLoad.name &&
      !routerStackModule.canContinueExist.some((v: any) => v === payLoad.name)
    ) {
      return; //当前页连续跳转不走逻辑
    }
    // router.push(payLoad);
    routerStackModule.routerStack.unshift(payLoad);
    console.log("routerStack - push:", routerStackModule);
  } catch (e) {}
};

export const mergeRouterQuery = (payLoad: any) => {
  const { name, query } = payLoad;
  const routerStack = routerStackModule.routerStack;
  const findIndex = routerStack.findIndex((route: any) => {
    return route.name === name;
  });
  if (findIndex !== undefined && findIndex > -1) {
    const newRouter = {
      ...routerStack[findIndex]
    };
    newRouter.query = {
      ...newRouter.query,
      ...query
    };
    routerStack.splice(findIndex, 1, newRouter);
  }
  console.log("routerStack:", routerStackModule);
};

export const routerInclude = (payLoad: any) => {
  const { routerStack } = routerStackModule;
  console.log("routerStack", routerStack);
  const findRoute = routerStack.find((route: any) => {
    return route.name === payLoad;
  });
  if (findRoute === undefined || findRoute === null) {
    return false;
  } else {
    return findRoute;
  }
};

export const routerIncludeVip = () => {
  const route =
    routerInclude("VipCenter") ||
    routerInclude("VipRetainPlanB") ||
    routerInclude("VipCenterPlanB");
  return route;
};

export const routerIncludeTimes = (payLoad: any) => {
  const { routerStack } = routerStackModule;
  let nums: number = 0;
  for (const route of routerStack) {
    if (route.name === payLoad) {
      nums++;
    }
  }
  return nums;
};

export const clearRouteStack = () => {
  routerStackModule.routerStack = [];
};
